import { LinearProgress, makeStyles } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { selLoaderLoading } from "store/loader/loaderSlice";
/* -------------------------------------------------------------------------- */
const PROGRESSBAR_HEIGHT = 4;
/* -------------------------------------------------------------------------- */
const ProgressBar = () => {
  const classes = useStyles();
  const isLoading = useSelector(selLoaderLoading);
  /* -------------------------------------------------------------------------- */
  return (
    <LinearProgress
      className={classes.progressBar}
      aria-label="Loading application"
      aria-hidden={!isLoading}
      style={{ visibility: isLoading ? "visible" : "hidden" }}
    />
  );
};
export default ProgressBar;
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  progressBar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: PROGRESSBAR_HEIGHT,
    zIndex: 1,
    backgroundColor: "transparent",
    "& .MuiLinearProgress-bar": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
